import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '@/state/store/auth';
import { useGetOrganizationByOrgId } from '@/graphql/queries/organizations';
import { LoadingOverlay } from '@/components/core';
import { NewOrgTemplateForm } from '../components/new-org-template-form';

const OrgTemplateNewPage = () => {
  const { orgId: slug } = useParams<{ orgId: string }>();
  const navigate = useNavigate();
  const { activeOrgRole } = useAuthStore();
  const { data: org, isLoading } = useGetOrganizationByOrgId(slug);

  if (activeOrgRole !== 'org_admin' && activeOrgRole !== 'org_editor') {
    navigate(`/org/${slug}`, { replace: true });
    return null;
  }

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (!org) {
    navigate('/', { replace: true });
    return null;
  }

  return <NewOrgTemplateForm orgSlug={slug ?? ''} orgId={org.BlocksOrgId} />;
};

export default OrgTemplateNewPage;
